export default "__VITE_ASSET__ByATC55W__"